import { createFileRoute } from "@tanstack/react-router";
import { KsefInvoicesPage } from "@/features/ksef/ksef-invoices-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/dokumenty/ksef")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.dokumenty.ksef", location.pathname);
	},
	component: KsefInvoicesPage,
});
